
import Canvas from './Canvas.js'
import GL from './GL.js'

class Background {
  constructor (settings) {
    const containerID = settings.id
    this.canvas = new Canvas({
      container: containerID,
      id: 'gl',
      width: 'auto',
      height: 'auto'
    });
    this.ut = Math.random() * ((1457587253 % 1000) * .001); //Math.floor( new Date().getTime() / 1000 );
    var glController = new GL(this.canvas, settings.shader);
    
    glController.init();
    glController.makeFrame();
    
    this.gl = glController.getGL();
    this.program = glController.getProgram();
  }

  is_sp (){
    return this.canvas.width <= 768 ? true : false;
  }
  clear (){
    this.scroll = 0;
    this.mousex = 0;
    this.mousey = 0;
    this.gl.clearColor(0.0, 0.0, 0.0, .0);
    this.gl.clearDepth(1.0);
    this.gl.clear(this.gl.COLOR_BUFFER_BIT | this.gl.DEPTH_BUFFER_BIT);
    this.gl.flush();	
  }
  setScroll(value) {
    this.scroll = value
  }
  mouse (pos){
    this.mousex = pos.x;
    this.mousey = pos.y;
  }
  draw (frameCount){
    this.gl.clearColor(0.0, 0.0, 0.0, .0);
    this.gl.clearDepth(1.0);

    // this.gl.disable(this.gl.DEPTH_TEST)
    // this.gl.enable(this.gl.BLEND);
    // this.gl.blendFunc(this.gl.SRC_ALPHA, this.gl.ONE_MINUS_SRC_ALPHA);

    // this.gl.blendEquation(this.gl.FUNC_ADD);

    this.gl.clear(this.gl.COLOR_BUFFER_BIT | this.gl.DEPTH_BUFFER_BIT);
    this.gl.drawElements(this.gl.TRIANGLES, 6, this.gl.UNSIGNED_SHORT, 0);
    this.gl.uniform1f(this.gl.getUniformLocation(this.program, 'u_time'), (performance.now() * .001) + this.ut);
    this.gl.uniform1f(this.gl.getUniformLocation(this.program, 'u_zoom'), this.canvas.zoom());
    this.gl.uniform1f(this.gl.getUniformLocation(this.program, 'u_scroll'), this.scroll);
    this.gl.uniform2f(this.gl.getUniformLocation(this.program, 'u_resolution'), this.canvas.width, this.canvas.height);
    // alert(this.canvas.width + '/' + this.canvas.height)
    this.gl.uniform2f(this.gl.getUniformLocation(this.program, 'u_mouse'), this.mousex / this.canvas.width, this.mousey / this.canvas.height);
    this.gl.flush();	
  }
}


export default Background
